// // // src/app/client/dashboard.jsx
// // import { Link } from 'react-router-dom';
// // import FurnitureNavbar from '../../../components/layout/Nav';
// // import './dashboard.scss';
// // import { useEffect, useState } from 'react';
// // import withAuth from '../../auth/WithAuth';
// // import { serverUrlAuth } from '../../../serverUrl';
// // import SpotlightTour from '../../../components/SpotlightTour';
// // import {
// //   FaHandshake,
// //   FaBell,
// //   FaProjectDiagram,
// //   FaCheckCircle,
// //   FaCalendarAlt,
// //   FaRocket,
// //   FaChevronRight,
// //   FaFileAlt,
// // } from 'react-icons/fa';

// // const ClientDashboard = () => {
// //   const [fullName, setFullName] = useState('');
// //   const [dashboardData, setDashboardData] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [showTour, setShowTour] = useState(false);

// //   useEffect(() => {
// //     const name = localStorage.getItem('full_name');
// //     if (name) setFullName(name.split(' ')[0]);

// //     const fetchDashboardData = async () => {
// //       try {
// //         const response = await serverUrlAuth.get('projects/client-dashboard/');
// //         console.log('Dashboard data:', response.data);
// //         setDashboardData(response.data);
// //       } catch (err) {
// //         console.error('Error fetching dashboard:', err);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchDashboardData();

// //     // Check if tour should be shown
// //     const tourCompleted = localStorage.getItem('dashboard_tour_completed');
// //     if (!tourCompleted) {
// //       // Wait for dashboard to fully render
// //       setTimeout(() => {
// //         setShowTour(true);
// //         console.log('Tour started!');
// //       }, 1500);
// //     }
// //   }, []);

// //   const handleTourComplete = () => {
// //     console.log('Tour completed - setting localStorage');
// //     setShowTour(false);
// //     localStorage.setItem('dashboard_tour_completed', 'true');
// //   };

// //   const handleTourSkip = () => {
// //     console.log('Tour skipped - setting localStorage');
// //     setShowTour(false);
// //     localStorage.setItem('dashboard_tour_completed', 'true');
// //   };

// //   // Reset tour function
// //   const resetTour = () => {
// //     console.log('Resetting tour...');
// //     localStorage.removeItem('dashboard_tour_completed');
// //     setShowTour(false);
// //     setTimeout(() => {
// //       setShowTour(true);
// //       console.log('Tour reset and restarted!');
// //     }, 100);
// //   };

// //   if (loading) {
// //     return (
// //       <>
// //         <FurnitureNavbar />
// //         <div className="dashboard-loader">
// //           <div className="wooden-spinner"></div>
// //           <p>Crafting your experience...</p>
// //         </div>
// //       </>
// //     );
// //   }

// //   const data = dashboardData || {};

// //   // Define tour steps - ADDED Messages button, REMOVED hero section
// //   const tourSteps = [
// //     {
// //       selector: '.tour-dashboard',
// //       title: '🏠 Your Dashboard',
// //       description: 'This is your Artiza home base. See your projects, activity, and important updates.',
// //       icon: '🏠',
// //     },
// //     {
// //       selector: '.tour-projects',
// //       title: '📋 Your Projects',
// //       description: 'View all the custom projects you\'ve requested. See which artisans have been matched to work on your projects, review their proposals, negotiate prices and timelines, and choose the best fit for your vision.',
// //       icon: '📋',
// //     },
// //     {
// //       selector: '.tour-progress',
// //       title: '📊 Track Progress',
// //       description: 'Follow the progress of your ongoing projects from request to completion.',
// //       icon: '📊',
// //     },
// //     {
// //       selector: '.tour-messages',
// //       title: '💬 Messages',
// //       description: 'Chat directly with artisans about your projects. Discuss details, negotiate, and stay updated on the progress of your product.',
// //       icon: '💬',
// //     },
// //     {
// //       selector: '.tour-payments',
// //       title: '💰 Payments',
// //       description: 'View your project payments and payment history from here.',
// //       icon: '💰',
// //     },
// //     {
// //       selector: '.tour-mode-switch',
// //       title: '🛍️ Switch to Shop',
// //       description: 'Looking for something ready-made? Switch to the shop to browse available products from artisans.',
// //       icon: '🛍️',
// //     },
// //     {
// //       selector: '.tour-help-desk',
// //       title: '❓ Help Desk',
// //       description: 'Contact Artiza support whenever you need assistance with your projects or account.',
// //       icon: '❓',
// //     },
// //     {
// //       selector: '.btn-primary-custom',
// //       title: '🚀 Start a Project',
// //       description: 'Have something custom in mind? Create a project and tell an artisan exactly what you need.',
// //       icon: '🚀',
// //     },
// //     {
// //       selector: '.btn-secondary-custom',
// //       title: '💬 Check Messages',
// //       description: 'View your messages and see if you have any unread notifications from artisans.',
// //       icon: '💬',
// //     },
// //     {
// //       selector: '.stats-dashboard',
// //       title: '📈 Project Overview',
// //       description: 'Quickly see how many projects are open, in progress, completed, or being negotiated.',
// //       icon: '📈',
// //     },
// //     {
// //       selector: '.projects-showcase',
// //       title: '🔍 Ongoing Projects',
// //       description: 'Track the progress of your active projects. See what\'s being worked on and when it\'s due.',
// //       icon: '🔍',
// //     },
// //     {
// //       selector: '.updates-card',
// //       title: '🔔 Recent Updates',
// //       description: 'Stay informed with the latest updates on your projects. New updates are marked with a badge.',
// //       icon: '🔔',
// //     },
// //     {
// //       selector: '.proposals-card',
// //       title: '📄 Recent Proposals',
// //       description: 'Review proposals from artisans. Compare prices, timelines, and choose the best fit for your project.',
// //       icon: '📄',
// //     },
// //   ];

// //   return (
// //     <>
// //       <FurnitureNavbar />
      
// //       <SpotlightTour
// //         steps={tourSteps}
// //         tourKey="dashboard_tour_completed"
// //         onComplete={handleTourComplete}
// //         onSkip={handleTourSkip}
// //         enabled={showTour}
// //       />


// //       <div className="modern-dashboard">
// //         {/* Hero Section */}
// //         <section className="hero-craftsmanship">
// //           <div className="hero-pattern"></div>
// //           <div className="hero-content-modern">
// //             <div className="welcome-badge">
// //               <span className="badge-icon">✨</span>
// //               <span>
// //                 Welcome back,{' '}
// //                 {fullName || data.client_name?.split(' ')[0] || 'Client'}!
// //               </span>
// //             </div>
// //             <h1 className="hero-title">
// //               <span className="gradient-text">Build With Confidence</span>
// //             </h1>
// //             <p className="hero-subtitle">
// //               Discover authentic craftsmanship from Kenya’s finest makers — from custom-made pieces to ready-made products.
// //             </p>
// //             <div className="hero-actions">
// //               <Link to="/new-project" className="btn-primary-custom">
// //                 <FaRocket /> Start New Project
// //               </Link>
// //               <Link to="/messages" className="btn-secondary-custom tour-messages-btn">
// //                 Messages
// //                 {data.combined_unread_negotiation_and_updates > 0 && (
// //                   <span className="notification-dot">
// //                     {data.combined_unread_negotiation_and_updates}
// //                   </span>
// //                 )}
// //               </Link>
// //             </div>
// //           </div>
// //         </section>

// //         {/* Quick Stats Dashboard */}
// //         <div className="stats-dashboard">
// //           <div className="stat-card-modern">
// //             <div
// //               className="stat-icon-wrapper"
// //               style={{ background: '#67320020', color: '#673200' }}
// //             >
// //               <FaProjectDiagram />
// //             </div>
// //             <div className="stat-content">
// //               <h3>{data.open_projects || 0}</h3>
// //               <p>Open Projects</p>
// //             </div>
// //           </div>
// //           <div className="stat-card-modern">
// //             <div
// //               className="stat-icon-wrapper"
// //               style={{ background: '#4caf5020', color: '#4caf50' }}
// //             >
// //               <FaCheckCircle />
// //             </div>
// //             <div className="stat-content">
// //               <h3>{data.ongoing_projects || 0}</h3>
// //               <p>In Progress</p>
// //             </div>
// //           </div>
// //           <div className="stat-card-modern">
// //             <div
// //               className="stat-icon-wrapper"
// //               style={{ background: '#ff980020', color: '#ff9800' }}
// //             >
// //               <FaCheckCircle />
// //             </div>
// //             <div className="stat-content">
// //               <h3>{data.completed_projects || 0}</h3>
// //               <p>Completed</p>
// //             </div>
// //           </div>
// //           <div className="stat-card-modern">
// //             <div
// //               className="stat-icon-wrapper"
// //               style={{ background: '#9c27b020', color: '#9c27b0' }}
// //             >
// //               <FaHandshake />
// //             </div>
// //             <div className="stat-content">
// //               <h3>{data.active_negotiations?.length || 0}</h3>
// //               <p>Negotiations</p>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Projects Grid Section - Ongoing Projects */}
// //         {data.ongoing_projects_data &&
// //           data.ongoing_projects_data.length > 0 && (
// //             <div className="projects-showcase" id="ongoing-projects">
// //               <div className="section-header-modern">
// //                 <h2>
// //                   <span className="header-icon">🔍</span>
// //                   Ongoing Projects
// //                   <span className="header-line"></span>
// //                 </h2>
// //                 <Link to="/my-requests" className="view-all-link">
// //                   View All Projects <FaChevronRight />
// //                 </Link>
// //               </div>
// //               <div className="projects-grid-modern">
// //                 {data.ongoing_projects_data.map((project) => (
// //                   <div key={project.id} className="project-card-modern">
// //                     <div className="project-header">
// //                       <div className="project-title-section">
// //                         <h3>{project.title}</h3>
// //                         <span className="project-artisan">
// //                           {project.artisan_name || 'Artisan assigned'}
// //                         </span>
// //                       </div>
// //                       <div className="project-budget">
// //                         KSh {(project.agreed_cost || 0).toLocaleString()}
// //                       </div>
// //                     </div>
// //                     <div className="progress-modern">
// //                       <div className="progress-bar-modern">
// //                         <div
// //                           className="progress-fill-modern"
// //                           style={{ width: `${project.progress || 0}%` }}
// //                         ></div>
// //                       </div>
// //                       <div className="progress-stats">
// //                         <span>{project.progress || 0}% Complete</span>
// //                         <span>
// //                           Due{' '}
// //                           {project.due_date
// //                             ? new Date(project.due_date).toLocaleDateString()
// //                             : 'Not set'}
// //                         </span>
// //                       </div>
// //                     </div>
// //                     <div className="project-footer">
// //                       <Link to={`/messages`} className="project-action">
// //                         View Updates →
// //                       </Link>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //           )}

// //         {/* Two Column Layout */}
// //         <div className="dashboard-grid-modern">
// //           {/* Left Column - Recent Updates */}
// //           <div className="dashboard-card updates-card" id="recent-updates">
// //             <div className="card-header">
// //               <h3>
// //                 <FaBell /> Recent Updates
// //               </h3>
// //               <Link to="/project-updates" className="card-link">
// //                 See all
// //               </Link>
// //             </div>
// //             <div className="activity-timeline">
// //               {data.update_notifications &&
// //               data.update_notifications.length > 0 ? (
// //                 data.update_notifications.slice(0, 5).map((update) => (
// //                   <div
// //                     key={update.id}
// //                     className={`timeline-item ${!update.is_read ? 'new' : ''}`}
// //                   >
// //                     <div className="timeline-dot"></div>
// //                     <div className="timeline-content">
// //                       <div className="timeline-header">
// //                         <h4>{update.project_title}</h4>
// //                         {!update.is_read && (
// //                           <span className="new-badge">New</span>
// //                         )}
// //                       </div>
// //                       <p>{update.message}</p>
// //                       <span className="timeline-time">{update.time}</span>
// //                     </div>
// //                   </div>
// //                 ))
// //               ) : (
// //                 <div className="empty-activity">
// //                   <p>No recent updates</p>
// //                 </div>
// //               )}
// //             </div>
// //           </div>

// //           {/* Right Column - Recent Proposals */}
// //           <div className="dashboard-card proposals-card" id="recent-proposals">
// //             <div className="card-header">
// //               <h3>
// //                 <FaFileAlt /> Recent Proposals
// //               </h3>
// //               <Link to="/my-requests" className="card-link">
// //                 View all →
// //               </Link>
// //             </div>
// //             <div className="proposals-list">
// //               {data.proposal_notifications &&
// //               data.proposal_notifications.length > 0 ? (
// //                 data.proposal_notifications.map((proposal) => (
// //                   <div key={proposal.id} className="proposal-item">
// //                     <div className="proposal-header">
// //                       <div className="proposal-project">
// //                         <h4>{proposal.project_title}</h4>
// //                         <span className="proposal-artisan">
// //                           {proposal.artisan_name}
// //                         </span>
// //                       </div>
// //                       <div className="proposal-price">
// //                         KSh {proposal.proposed_price?.toLocaleString() || 0}
// //                       </div>
// //                     </div>
// //                     <div className="proposal-details">
// //                       <div className="proposal-footer">
// //                         <span className="proposal-date">
// //                           <FaCalendarAlt /> Due:{' '}
// //                           {proposal.completion_date
// //                             ? new Date(
// //                                 proposal.completion_date,
// //                               ).toLocaleDateString()
// //                             : 'Not set'}
// //                         </span>
// //                         <Link to={`/projects`} className="review-proposal-btn">
// //                           Review Proposal →
// //                         </Link>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 ))
// //               ) : (
// //                 <div className="empty-proposals">
// //                   <p>No proposals received yet</p>
// //                 </div>
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </>
// //   );
// // };

// // export default withAuth(ClientDashboard, 'client');


// // src/pages/client/Dashboard.jsx
// import { Link } from 'react-router-dom';
// import './dashboard.scss';
// import { useEffect, useState } from 'react';
// import withAuth from '../../auth/WithAuth';
// import { serverUrlAuth } from '../../../serverUrl';
// import SpotlightTour from '../../../components/SpotlightTour';
// import Sidebar from '../../../components/layout/Sidebar';
// import {
//   FaHandshake,
//   FaProjectDiagram,
//   FaCheckCircle,
//   FaCalendarAlt,
//   FaRocket,
//   FaChevronRight,
//   FaFileAlt,
//   FaEnvelope,
//   FaClock,
//   FaSyncAlt,
//   FaArrowRight,
//   FaStore,
//   FaPalette,
//   FaLayerGroup,
//   FaBolt,
// } from 'react-icons/fa';

// const ClientDashboard = () => {
//   const [fullName, setFullName] = useState('');
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const [showTour, setShowTour] = useState(false);
//   const [activeSection, setActiveSection] = useState('overview');

//   const fetchDashboardData = async (isRefresh = false) => {
//     if (isRefresh) setRefreshing(true);
//     try {
//       const response = await serverUrlAuth.get('projects/client-dashboard/');
//       setDashboardData(response.data);
//     } catch (err) {
//       console.error('Error fetching dashboard:', err);
//     } finally {
//       setLoading(false);
//       setRefreshing(false);
//     }
//   };

//   useEffect(() => {
//     const name = localStorage.getItem('full_name');
//     if (name) setFullName(name.split(' ')[0]);

//     fetchDashboardData();

//     const tourCompleted = localStorage.getItem('dashboard_tour_completed');
//     if (!tourCompleted) {
//       setTimeout(() => setShowTour(true), 1500);
//     }
//   }, []);

//   const handleTourComplete = () => {
//     setShowTour(false);
//     localStorage.setItem('dashboard_tour_completed', 'true');
//   };

//   const handleTourSkip = () => {
//     setShowTour(false);
//     localStorage.setItem('dashboard_tour_completed', 'true');
//   };

//   if (loading) {
//     return (
//       <>
//         <Sidebar />
//         <div className="dashboard-loader">
//           <div className="orbit-spinner">
//             <div></div>
//             <div></div>
//             <div></div>
//           </div>
//           <p>Crafting your experience…</p>
//         </div>
//       </>
//     );
//   }

//   const data = dashboardData || {};

//   const tourSteps = [
//     {
//       selector: '.tour-dashboard',
//       title: '🏠 Your Dashboard',
//       description:
//         'This is your Artiza home base. See your projects, activity, and important updates.',
//       icon: '🏠',
//     },
//     {
//       selector: '.tour-projects',
//       title: '📋 Your Projects',
//       description:
//         "View all the custom projects you've requested, review proposals, negotiate, and choose the best artisan.",
//       icon: '📋',
//     },
//     {
//       selector: '.tour-progress',
//       title: '📊 Track Progress',
//       description:
//         'Follow the progress of your ongoing projects from request to completion.',
//       icon: '📊',
//     },
//     {
//       selector: '.tour-messages',
//       title: '💬 Messages',
//       description: 'Chat directly with artisans about your projects.',
//       icon: '💬',
//     },
//     {
//       selector: '.tour-payments',
//       title: '💰 Payments',
//       description: 'View your project payments and payment history.',
//       icon: '💰',
//     },
//     {
//       selector: '.tour-mode-switch',
//       title: '🛍️ Switch to Shop',
//       description: 'Browse ready-made products from artisans.',
//       icon: '🛍️',
//     },
//     {
//       selector: '.tour-help-desk',
//       title: '❓ Help Desk',
//       description: 'Contact Artiza support whenever you need assistance.',
//       icon: '❓',
//     },
//     {
//       selector: '.btn-primary-custom',
//       title: '🚀 Start a Project',
//       description: 'Have something custom in mind? Create a project.',
//       icon: '🚀',
//     },
//     {
//       selector: '.stats-dashboard',
//       title: '📈 Project Overview',
//       description:
//         'Quickly see how many projects are open, in progress, completed, or being negotiated.',
//       icon: '📈',
//     },
//     {
//       selector: '.projects-showcase',
//       title: '🔍 Ongoing Projects',
//       description: 'Track the progress of your active projects.',
//       icon: '🔍',
//     },
//     {
//       selector: '.updates-card',
//       title: '🔔 Recent Updates',
//       description: 'Stay informed with the latest updates on your projects.',
//       icon: '🔔',
//     },
//     {
//       selector: '.proposals-card',
//       title: '📄 Recent Proposals',
//       description: 'Review proposals from artisans.',
//       icon: '📄',
//     },
//   ];

//   const heroStats = [
//     {
//       key: 'open',
//       icon: <FaProjectDiagram />,
//       label: 'Open Projects',
//       value: data.open_projects || 0,
//       sub: data.open_projects > 0 ? 'Seeking artisans' : 'None active',
//       accent: 'gold',
//     },
//     {
//       key: 'progress',
//       icon: <FaClock />,
//       label: 'In Progress',
//       value: data.ongoing_projects || 0,
//       sub:
//         data.ongoing_projects > 0
//           ? 'Active work'
//           : 'No projects in progress',
//       accent: 'blue',
//     },
//     {
//       key: 'completed',
//       icon: <FaCheckCircle />,
//       label: 'Completed',
//       value: data.completed_projects || 0,
//       sub: 'Finished successfully',
//       accent: 'violet',
//     },
//     {
//       key: 'negotiations',
//       icon: <FaHandshake />,
//       label: 'Negotiations',
//       value: data.active_negotiations?.length || 0,
//       sub:
//         (data.active_negotiations?.length || 0) > 0
//           ? 'Awaiting your reply'
//           : 'No active talks',
//       accent: 'emerald',
//     },
//   ];

//   const unread = data.combined_unread_negotiation_and_updates || 0;

//   const sections = [
//     { key: 'overview', label: 'Overview', icon: <FaLayerGroup /> },
//     { key: 'projects', label: 'Projects', icon: <FaProjectDiagram /> },
//     { key: 'activity', label: 'Activity', icon: <FaBolt /> },
//   ];

//   return (
//     <>
//       <Sidebar />

//       <SpotlightTour
//         steps={tourSteps}
//         tourKey="dashboard_tour_completed"
//         onComplete={handleTourComplete}
//         onSkip={handleTourSkip}
//         enabled={showTour}
//       />

//       <div className="modern-dashboard">
//         {/* ============ COMMAND BAR ============ */}
//         <div className="command-bar">
//           <div className="command-left">
//             <div className="command-brand">
//               <FaPalette className="command-bolt" />
//               <span>Client Workspace</span>
//             </div>
//             <span className="command-divider" />
//             <span className="command-status">
//               <span className="pulse-dot green" /> All systems operational
//             </span>
//           </div>
//           <div className="command-right">
//             <Link to="/messages" className="icon-chip tour-messages">
//               <FaEnvelope />
//               {unread > 0 && <span className="notif-dot">{unread}</span>}
//             </Link>
//             <button
//               className={`icon-btn ${refreshing ? 'spinning' : ''}`}
//               onClick={() => fetchDashboardData(true)}
//               disabled={refreshing}
//               title="Refresh"
//             >
//               <FaSyncAlt />
//             </button>
//           </div>
//         </div>

//         {/* ============ HERO ============ */}
//         <section className="hero tour-dashboard">
//           <div className="hero-bg">
//             <div className="hero-orb orb-1" />
//             <div className="hero-orb orb-2" />
//             <div className="hero-grid" />
//           </div>
//           <div className="hero-content">
//             <div className="hero-text">
//               <span className="hero-eyebrow">CLIENT · ARTIZA PLATFORM</span>
//               <h1>
//                 Welcome back,{' '}
//                 <span className="accent">{fullName || 'Client'}</span>
//               </h1>
//               <p>
//                 Discover authentic craftsmanship from Kenya's finest makers —
//                 track your projects, review proposals, and stay updated.
//               </p>

//               <div className="hero-actions">
//                 <Link to="/new-project" className="btn-primary-custom">
//                   <FaRocket /> Start New Project
//                 </Link>
//                 <Link to="/ready-made-products" className="btn-secondary-custom">
//                   <FaStore /> Browse Ready-Made
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <div className="hero-kpi-grid stats-dashboard">
//             {heroStats.map((stat) => (
//               <div
//                 key={stat.key}
//                 className={`hero-kpi accent-${stat.accent}`}
//               >
//                 <div className="hero-kpi-glow" />
//                 <div className="hero-kpi-top">
//                   <div className="hero-kpi-icon">{stat.icon}</div>
//                 </div>
//                 <div className="hero-kpi-label">{stat.label}</div>
//                 <div className="hero-kpi-value">{stat.value}</div>
//                 <div className="hero-kpi-sub">{stat.sub}</div>
//                 <div className="hero-kpi-bar" />
//               </div>
//             ))}
//           </div>
//         </section>

//         {/* ============ SEGMENTED NAV ============ */}
//         <div className="segment-nav">
//           {sections.map((s) => (
//             <button
//               key={s.key}
//               className={`segment ${activeSection === s.key ? 'active' : ''}`}
//               onClick={() => setActiveSection(s.key)}
//             >
//               {s.icon}
//               <span>{s.label}</span>
//             </button>
//           ))}
//         </div>

//         {/* ============ OVERVIEW ============ */}
//         {activeSection === 'overview' && (
//           <div className="section-reveal">
//             <div className="dashboard-grid-modern">
//               <section className="panel projects-panel projects-showcase tour-projects">
//                 <div className="panel-header">
//                   <div>
//                     <h2>
//                       <span className="panel-number">01</span> Ongoing Projects
//                     </h2>
//                     <p>Track what artisans are working on right now</p>
//                   </div>
//                   <Link to="/my-requests" className="panel-link">
//                     View all <FaChevronRight />
//                   </Link>
//                 </div>

//                 {data.ongoing_projects_data &&
//                 data.ongoing_projects_data.length > 0 ? (
//                   <div className="projects-grid-modern">
//                     {data.ongoing_projects_data.map((project) => (
//                       <div
//                         key={project.id}
//                         className="project-card-modern tour-progress"
//                       >
//                         <div className="project-header">
//                           <div className="project-title-section">
//                             <h3>{project.title}</h3>
//                             <span className="project-artisan">
//                               {project.artisan_name || 'Awaiting artisan'}
//                             </span>
//                           </div>
//                           <div className="project-budget">
//                             KSh {(project.agreed_cost || 0).toLocaleString()}
//                           </div>
//                         </div>
//                         <div className="progress-modern">
//                           <div className="progress-bar-modern">
//                             <div
//                               className="progress-fill-modern"
//                               style={{ width: `${project.progress || 0}%` }}
//                             ></div>
//                           </div>
//                           <div className="progress-stats">
//                             <span>{project.progress || 0}% complete</span>
//                             <span>
//                               Due{' '}
//                               {project.due_date
//                                 ? new Date(
//                                     project.due_date,
//                                   ).toLocaleDateString()
//                                 : 'Not set'}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="project-footer">
//                           <Link to="/messages" className="project-action">
//                             View Updates <FaArrowRight />
//                           </Link>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="empty-state">
//                     <FaProjectDiagram />
//                     <h3>No active projects yet</h3>
//                     <p>
//                       Once you start a project and hire an artisan, it will
//                       appear here.
//                     </p>
//                     <Link to="/new-project" className="empty-cta">
//                       <FaRocket /> Start your first project
//                     </Link>
//                   </div>
//                 )}
//               </section>

//               <section className="panel updates-card tour-payments">
//                 <div className="panel-header">
//                   <div>
//                     <h2>
//                       <span className="panel-number">02</span> Recent Updates
//                     </h2>
//                     <p>Latest activity from your projects</p>
//                   </div>
//                   <Link to="/project-updates" className="panel-link">
//                     See all
//                   </Link>
//                 </div>
//                 <div className="activity-timeline">
//                   {data.update_notifications &&
//                   data.update_notifications.length > 0 ? (
//                     data.update_notifications.slice(0, 5).map((update) => (
//                       <div
//                         key={update.id}
//                         className={`timeline-item ${
//                           !update.is_read ? 'new' : ''
//                         }`}
//                       >
//                         <div className="timeline-dot"></div>
//                         <div className="timeline-content">
//                           <div className="timeline-header">
//                             <h4>{update.project_title}</h4>
//                             {!update.is_read && (
//                               <span className="new-badge">New</span>
//                             )}
//                           </div>
//                           <p>{update.message}</p>
//                           <span className="timeline-time">{update.time}</span>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="empty-activity">
//                       <p>No recent updates</p>
//                     </div>
//                   )}
//                 </div>
//               </section>

//               <section className="panel proposals-card">
//                 <div className="panel-header">
//                   <div>
//                     <h2>
//                       <span className="panel-number">03</span> Recent Proposals
//                     </h2>
//                     <p>Proposals from artisans on your projects</p>
//                   </div>
//                   <Link to="/my-requests" className="panel-link">
//                     View all <FaChevronRight />
//                   </Link>
//                 </div>
//                 <div className="proposals-list">
//                   {data.proposal_notifications &&
//                   data.proposal_notifications.length > 0 ? (
//                     data.proposal_notifications.map((proposal) => (
//                       <div key={proposal.id} className="proposal-item">
//                         <div className="proposal-header">
//                           <div className="proposal-project">
//                             <h4>{proposal.project_title}</h4>
//                             <span className="proposal-artisan">
//                               {proposal.artisan_name}
//                             </span>
//                           </div>
//                           <div className="proposal-price">
//                             KSh{' '}
//                             {proposal.proposed_price?.toLocaleString() || 0}
//                           </div>
//                         </div>
//                         <div className="proposal-details">
//                           <div className="proposal-footer">
//                             <span className="proposal-date">
//                               <FaCalendarAlt /> Due:{' '}
//                               {proposal.completion_date
//                                 ? new Date(
//                                     proposal.completion_date,
//                                   ).toLocaleDateString()
//                                 : 'Not set'}
//                             </span>
//                             <Link
//                               to="/projects"
//                               className="review-proposal-btn"
//                             >
//                               Review <FaArrowRight />
//                             </Link>
//                           </div>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="empty-proposals">
//                       <p>No proposals received yet</p>
//                       <span>
//                         Create a project to start receiving proposals.
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               </section>
//             </div>
//           </div>
//         )}

//         {/* ============ PROJECTS ============ */}
//         {activeSection === 'projects' && (
//           <div className="section-reveal">
//             <section className="panel">
//               <div className="panel-header">
//                 <div>
//                   <h2>
//                     <span className="panel-number">01</span> All Ongoing Projects
//                   </h2>
//                   <p>Every active project you have with artisans</p>
//                 </div>
//                 <Link to="/my-requests" className="panel-link">
//                   View all <FaChevronRight />
//                 </Link>
//               </div>

//               {data.ongoing_projects_data &&
//               data.ongoing_projects_data.length > 0 ? (
//                 <div className="projects-grid-modern full">
//                   {data.ongoing_projects_data.map((project) => (
//                     <div key={project.id} className="project-card-modern">
//                       <div className="project-header">
//                         <div className="project-title-section">
//                           <h3>{project.title}</h3>
//                           <span className="project-artisan">
//                             {project.artisan_name || 'Awaiting artisan'}
//                           </span>
//                         </div>
//                         <div className="project-budget">
//                           KSh {(project.agreed_cost || 0).toLocaleString()}
//                         </div>
//                       </div>
//                       <div className="progress-modern">
//                         <div className="progress-bar-modern">
//                           <div
//                             className="progress-fill-modern"
//                             style={{ width: `${project.progress || 0}%` }}
//                           ></div>
//                         </div>
//                         <div className="progress-stats">
//                           <span>{project.progress || 0}% complete</span>
//                           <span>
//                             Due{' '}
//                             {project.due_date
//                               ? new Date(
//                                   project.due_date,
//                                 ).toLocaleDateString()
//                               : 'Not set'}
//                           </span>
//                         </div>
//                       </div>
//                       <div className="project-footer">
//                         <Link to="/messages" className="project-action">
//                           View Updates <FaArrowRight />
//                         </Link>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="empty-state">
//                   <FaProjectDiagram />
//                   <h3>No active projects yet</h3>
//                   <p>
//                     Once you start a project and hire an artisan, it will
//                     appear here.
//                   </p>
//                   <Link to="/new-project" className="empty-cta">
//                     <FaRocket /> Start your first project
//                   </Link>
//                 </div>
//               )}
//             </section>
//           </div>
//         )}

//         {/* ============ ACTIVITY ============ */}
//         {activeSection === 'activity' && (
//           <div className="section-reveal">
//             <div className="dashboard-grid-modern two-equal">
//               <section className="panel updates-card">
//                 <div className="panel-header">
//                   <div>
//                     <h2>
//                       <span className="panel-number">01</span> Recent Updates
//                     </h2>
//                     <p>Latest activity from your projects</p>
//                   </div>
//                   <Link to="/project-updates" className="panel-link">
//                     See all
//                   </Link>
//                 </div>
//                 <div className="activity-timeline">
//                   {data.update_notifications &&
//                   data.update_notifications.length > 0 ? (
//                     data.update_notifications.map((update) => (
//                       <div
//                         key={update.id}
//                         className={`timeline-item ${
//                           !update.is_read ? 'new' : ''
//                         }`}
//                       >
//                         <div className="timeline-dot"></div>
//                         <div className="timeline-content">
//                           <div className="timeline-header">
//                             <h4>{update.project_title}</h4>
//                             {!update.is_read && (
//                               <span className="new-badge">New</span>
//                             )}
//                           </div>
//                           <p>{update.message}</p>
//                           <span className="timeline-time">{update.time}</span>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="empty-activity">
//                       <p>No recent updates</p>
//                     </div>
//                   )}
//                 </div>
//               </section>

//               <section className="panel proposals-card">
//                 <div className="panel-header">
//                   <div>
//                     <h2>
//                       <span className="panel-number">02</span> Recent Proposals
//                     </h2>
//                     <p>Proposals from artisans on your projects</p>
//                   </div>
//                   <Link to="/my-requests" className="panel-link">
//                     View all <FaChevronRight />
//                   </Link>
//                 </div>
//                 <div className="proposals-list">
//                   {data.proposal_notifications &&
//                   data.proposal_notifications.length > 0 ? (
//                     data.proposal_notifications.map((proposal) => (
//                       <div key={proposal.id} className="proposal-item">
//                         <div className="proposal-header">
//                           <div className="proposal-project">
//                             <h4>{proposal.project_title}</h4>
//                             <span className="proposal-artisan">
//                               {proposal.artisan_name}
//                             </span>
//                           </div>
//                           <div className="proposal-price">
//                             KSh{' '}
//                             {proposal.proposed_price?.toLocaleString() || 0}
//                           </div>
//                         </div>
//                         <div className="proposal-details">
//                           <div className="proposal-footer">
//                             <span className="proposal-date">
//                               <FaCalendarAlt /> Due:{' '}
//                               {proposal.completion_date
//                                 ? new Date(
//                                     proposal.completion_date,
//                                   ).toLocaleDateString()
//                                 : 'Not set'}
//                             </span>
//                             <Link
//                               to="/projects"
//                               className="review-proposal-btn"
//                             >
//                               Review <FaArrowRight />
//                             </Link>
//                           </div>
//                         </div>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="empty-proposals">
//                       <p>No proposals received yet</p>
//                     </div>
//                   )}
//                 </div>
//               </section>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default withAuth(ClientDashboard, 'client');

// src/pages/client/Dashboard.jsx
import { Link } from 'react-router-dom';
import './dashboard.scss';
import { useEffect, useState } from 'react';
import withAuth from '../../auth/WithAuth';
import { serverUrlAuth } from '../../../serverUrl';
import SpotlightTour from '../../../components/SpotlightTour';
import Sidebar from '../../../components/layout/Sidebar';
import {
  FaHandshake,
  FaProjectDiagram,
  FaCheckCircle,
  FaCalendarAlt,
  FaRocket,
  FaChevronRight,
  FaFileAlt,
  FaEnvelope,
  FaClock,
  FaSyncAlt,
  FaArrowRight,
  FaStore,
  FaPalette,
  FaLayerGroup,
  FaBolt,
  FaBell,
} from 'react-icons/fa';

const ClientDashboard = () => {
  const [fullName, setFullName] = useState('');
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [showTour, setShowTour] = useState(false);
  const [activeSection, setActiveSection] = useState('overview');

  const fetchDashboardData = async (isRefresh = false) => {
    if (isRefresh) setRefreshing(true);
    try {
      const response = await serverUrlAuth.get('projects/client-dashboard/');
      setDashboardData(response.data);
    } catch (err) {
      console.error('Error fetching dashboard:', err);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    const name = localStorage.getItem('full_name');
    if (name) setFullName(name.split(' ')[0]);

    fetchDashboardData();

    const tourCompleted = localStorage.getItem('dashboard_tour_completed');
    if (!tourCompleted) {
      setTimeout(() => setShowTour(true), 1500);
    }
  }, []);

  const handleTourComplete = () => {
    setShowTour(false);
    localStorage.setItem('dashboard_tour_completed', 'true');
  };

  const handleTourSkip = () => {
    setShowTour(false);
    localStorage.setItem('dashboard_tour_completed', 'true');
  };

  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="dashboard-loader">
          <div className="orbit-spinner">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <p>Crafting your experience…</p>
        </div>
      </>
    );
  }

  const data = dashboardData || {};

  const tourSteps = [
    {
      selector: '.tour-dashboard',
      title: '🏠 Your Dashboard',
      description:
        'This is your Artiza home base. See your projects, activity, and important updates.',
      icon: '🏠',
    },
    {
      selector: '.tour-projects',
      title: '📋 Your Projects',
      description:
        "View all the custom projects you've requested, review proposals, negotiate, and choose the best artisan.",
      icon: '📋',
    },
    {
      selector: '.tour-progress',
      title: '📊 Track Progress',
      description:
        'Follow the progress of your ongoing projects from request to completion.',
      icon: '📊',
    },
    {
      selector: '.tour-messages',
      title: '💬 Messages',
      description: 'Chat directly with artisans about your projects.',
      icon: '💬',
    },
    {
      selector: '.tour-payments',
      title: '💰 Payments',
      description: 'View your project payments and payment history.',
      icon: '💰',
    },
    {
      selector: '.tour-mode-switch',
      title: '🛍️ Switch to Shop',
      description: 'Browse ready-made products from artisans.',
      icon: '🛍️',
    },
    {
      selector: '.tour-help-desk',
      title: '❓ Help Desk',
      description: 'Contact Artiza support whenever you need assistance.',
      icon: '❓',
    },
    {
      selector: '.btn-primary-custom',
      title: '🚀 Start a Project',
      description: 'Have something custom in mind? Create a project.',
      icon: '🚀',
    },
    {
      selector: '.stats-dashboard',
      title: '📈 Project Overview',
      description:
        'Quickly see how many projects are open, in progress, completed, or being negotiated.',
      icon: '📈',
    },
    {
      selector: '.projects-showcase',
      title: '🔍 Ongoing Projects',
      description: 'Track the progress of your active projects.',
      icon: '🔍',
    },
    {
      selector: '.updates-card',
      title: '🔔 Recent Updates',
      description: 'Stay informed with the latest updates on your projects.',
      icon: '🔔',
    },
    {
      selector: '.proposals-card',
      title: '📄 Recent Proposals',
      description: 'Review proposals from artisans.',
      icon: '📄',
    },
  ];

  const heroStats = [
    {
      key: 'open',
      icon: <FaProjectDiagram />,
      label: 'Open Projects',
      value: data.open_projects || 0,
      sub: data.open_projects > 0 ? 'Seeking artisans' : 'None active',
      accent: 'gold',
    },
    {
      key: 'progress',
      icon: <FaClock />,
      label: 'In Progress',
      value: data.ongoing_projects || 0,
      sub:
        data.ongoing_projects > 0
          ? 'Active work'
          : 'No projects in progress',
      accent: 'blue',
    },
    {
      key: 'completed',
      icon: <FaCheckCircle />,
      label: 'Completed',
      value: data.completed_projects || 0,
      sub: 'Finished successfully',
      accent: 'violet',
    },
    {
      key: 'negotiations',
      icon: <FaHandshake />,
      label: 'Negotiations',
      value: data.active_negotiations?.length || 0,
      sub:
        (data.active_negotiations?.length || 0) > 0
          ? 'Awaiting your reply'
          : 'No active talks',
      accent: 'emerald',
    },
  ];

  const unread = data.combined_unread_negotiation_and_updates || 0;

  const sections = [
    { key: 'overview', label: 'Overview', icon: <FaLayerGroup /> },
    { key: 'projects', label: 'Projects', icon: <FaProjectDiagram /> },
    { key: 'activity', label: 'Activity', icon: <FaBolt /> },
  ];

  return (
    <>
      <Sidebar />

      <SpotlightTour
        steps={tourSteps}
        tourKey="dashboard_tour_completed"
        onComplete={handleTourComplete}
        onSkip={handleTourSkip}
        enabled={showTour}
      />

      <div className="modern-dashboard">
       

        {/* ============ HERO ============ */}
        <section className="hero tour-dashboard">
          <div className="hero-bg">
            <div className="hero-orb orb-1" />
            <div className="hero-orb orb-2" />
            <div className="hero-grid" />
          </div>

          <div className="hero-content">
            <div className="hero-text">
              <span className="hero-eyebrow">
                <span className="eyebrow-dot" /> CLIENT · ARTIZA PLATFORM
              </span>
              <h1>
                Welcome back,{' '}
                <span className="accent">{fullName || 'Client'}</span>
              </h1>
              <p>
                Discover authentic craftsmanship from Kenya's finest makers —
                track your projects, review proposals, and stay updated.
              </p>

              <div className="hero-actions">
                <Link to="/new-project" className="btn-primary-custom">
                  <FaRocket /> Start New Project
                </Link>
                <Link
                  to="/ready-made-products"
                  className="btn-secondary-custom"
                >
                  <FaStore /> Browse Ready-Made
                </Link>
                <Link
                  to="/messages"
                  className="btn-secondary-custom tour-messages-btn"
                >
                  <FaEnvelope /> Messages
                  {unread > 0 && (
                    <span className="notification-dot">{unread}</span>
                  )}
                </Link>
              </div>
            </div>
          </div>

          <div className="hero-kpi-grid stats-dashboard">
            {heroStats.map((stat) => (
              <div
                key={stat.key}
                className={`hero-kpi accent-${stat.accent}`}
              >
                <div className="hero-kpi-glow" />
                <div className="hero-kpi-top">
                  <div className="hero-kpi-icon">{stat.icon}</div>
                </div>
                <div className="hero-kpi-label">{stat.label}</div>
                <div className="hero-kpi-value">{stat.value}</div>
                <div className="hero-kpi-sub">{stat.sub}</div>
                <div className="hero-kpi-bar" />
              </div>
            ))}
          </div>
        </section>

        {/* ============ SEGMENTED NAV ============ */}
        <div className="segment-nav">
          {sections.map((s) => (
            <button
              key={s.key}
              className={`segment ${
                activeSection === s.key ? 'active' : ''
              }`}
              onClick={() => setActiveSection(s.key)}
            >
              {s.icon}
              <span>{s.label}</span>
            </button>
          ))}
        </div>

        {/* ============ OVERVIEW ============ */}
        {activeSection === 'overview' && (
          <div className="section-reveal">
            <div className="overview-grid">
              {/* Projects panel — full width top */}
              <section className="panel projects-panel projects-showcase tour-projects">
                <div className="panel-header">
                  <div className="panel-title">
                    <span className="panel-number">01</span>
                    <div>
                      <h2>Ongoing Projects</h2>
                      {/* <p>Track what artisans are working on right now</p> */}
                    </div>
                  </div>
                  <Link to="/my-requests" className="panel-link">
                    View all <FaChevronRight />
                  </Link>
                </div>

                {data.ongoing_projects_data &&
                data.ongoing_projects_data.length > 0 ? (
                  <div className="projects-grid-modern">
                    {data.ongoing_projects_data.slice(0, 3).map((project) => (
                      <div
                        key={project.id}
                        className="project-card-modern tour-progress"
                      >
                        <div className="project-header">
                          <div className="project-title-section">
                            <h3>{project.title}</h3>
                            <span className="project-artisan">
                              {project.artisan_name || 'Awaiting artisan'}
                            </span>
                          </div>
                          <div className="project-budget">
                            KSh {(project.agreed_cost || 0).toLocaleString()}
                          </div>
                        </div>
                        <div className="progress-modern">
                          <div className="progress-bar-modern">
                            <div
                              className="progress-fill-modern"
                              style={{ width: `${project.progress || 0}%` }}
                            ></div>
                          </div>
                          <div className="progress-stats">
                            <span>{project.progress || 0}% complete</span>
                            <span>
                              Due{' '}
                              {project.due_date
                                ? new Date(
                                    project.due_date,
                                  ).toLocaleDateString()
                                : 'Not set'}
                            </span>
                          </div>
                        </div>
                        <div className="project-footer-client">
                          <Link to="/messages" className="project-action-client">
                            View Updates <FaArrowRight />
                          </Link>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="empty-state">
                    <div className="empty-icon-wrap">
                      <FaProjectDiagram />
                    </div>
                    <h3>No active projects yet</h3>
                    <p>
                      Once you start a project and hire an artisan, it will
                      appear here.
                    </p>
                    <Link to="/new-project" className="empty-cta">
                      <FaRocket /> Start your first project
                    </Link>
                  </div>
                )}
              </section>

              {/* Bottom row — Updates + Proposals side by side */}
              <div className="overview-bottom">
                <section className="panel updates-card tour-payments">
                  <div className="panel-header">
                    <div className="panel-title">
                      <span className="panel-number">02</span>
                      <div>
                        <h2>
                          <FaBell /> Recent Updates
                        </h2>
                        <p>Latest activity from your projects</p>
                      </div>
                    </div>
                    <Link to="/project-updates" className="panel-link">
                      See all
                    </Link>
                  </div>
                  <div className="activity-timeline">
                    {data.update_notifications &&
                    data.update_notifications.length > 0 ? (
                      data.update_notifications.slice(0, 3).map((update) => (
                        <div
                          key={update.id}
                          className={`timeline-item ${
                            !update.is_read ? 'new' : ''
                          }`}
                        >
                          <div className="timeline-dot"></div>
                          <div className="timeline-content">
                            <div className="timeline-header">
                              <h4>{update.project_title}</h4>
                              {!update.is_read && (
                                <span className="new-badge">New</span>
                              )}
                            </div>
                            <p>{update.message}</p>
                            <span className="timeline-time">{update.time}</span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="empty-activity">
                        <p>No recent updates</p>
                      </div>
                    )}
                  </div>
                </section>

                <section className="panel proposals-card">
                  <div className="panel-header">
                    <div className="panel-title">
                      <span className="panel-number">03</span>
                      <div>
                        <h2>
                          <FaFileAlt /> Recent Proposals
                        </h2>
                        <p>Proposals from artisans on your projects</p>
                      </div>
                    </div>
                    <Link to="/my-requests" className="panel-link">
                      View all <FaChevronRight />
                    </Link>
                  </div>
                  <div className="proposals-list">
                    {data.proposal_notifications &&
                    data.proposal_notifications.length > 0 ? (
                      data.proposal_notifications.slice(0,3).map((proposal) => (
                        <div key={proposal.id} className="proposal-item">
                          <div className="proposal-header">
                            <div className="proposal-project">
                              <h4>{proposal.project_title}</h4>
                              <span className="proposal-artisan">
                                {proposal.artisan_name}
                              </span>
                            </div>
                            <div className="proposal-price">
                              KSh{' '}
                              {proposal.proposed_price?.toLocaleString() || 0}
                            </div>
                          </div>
                          <div className="proposal-details">
                            <div className="proposal-footer">
                              <span className="proposal-date">
                                <FaCalendarAlt /> Due:{' '}
                                {proposal.completion_date
                                  ? new Date(
                                      proposal.completion_date,
                                    ).toLocaleDateString()
                                  : 'Not set'}
                              </span>
                              <Link
                                to="/projects"
                                className="review-proposal-btn"
                              >
                                Review <FaArrowRight />
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="empty-proposals">
                        <p>No proposals received yet</p>
                        <span>
                          Create a project to start receiving proposals.
                        </span>
                      </div>
                    )}
                  </div>
                </section>
              </div>
            </div>
          </div>
        )}

        {/* ============ PROJECTS ============ */}
        {activeSection === 'projects' && (
          <div className="section-reveal">
            <section className="panel">
              <div className="panel-header">
                <div className="panel-title">
                  <span className="panel-number">01</span>
                  <div>
                    <h2>All Ongoing Projects</h2>
                    <p>Every active project you have with artisans</p>
                  </div>
                </div>
                <Link to="/my-requests" className="panel-link">
                  View all <FaChevronRight />
                </Link>
              </div>

              {data.ongoing_projects_data &&
              data.ongoing_projects_data.length > 0 ? (
                <div className="projects-grid-modern full">
                  {data.ongoing_projects_data.map((project) => (
                    <div key={project.id} className="project-card-modern">
                      <div className="project-header">
                        <div className="project-title-section">
                          <h3>{project.title}</h3>
                          <span className="project-artisan">
                            {project.artisan_name || 'Awaiting artisan'}
                          </span>
                        </div>
                        <div className="project-budget">
                          KSh {(project.agreed_cost || 0).toLocaleString()}
                        </div>
                      </div>
                      <div className="progress-modern">
                        <div className="progress-bar-modern">
                          <div
                            className="progress-fill-modern"
                            style={{ width: `${project.progress || 0}%` }}
                          ></div>
                        </div>
                        <div className="progress-stats">
                          <span>{project.progress || 0}% complete</span>
                          <span>
                            Due{' '}
                            {project.due_date
                              ? new Date(
                                  project.due_date,
                                ).toLocaleDateString()
                              : 'Not set'}
                          </span>
                        </div>
                      </div>
                      <div className="project-footer-client">
                        <Link to="/messages" className="project-action-client">
                          View Updates <FaArrowRight />
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-state">
                  <div className="empty-icon-wrap">
                    <FaProjectDiagram />
                  </div>
                  <h3>No active projects yet</h3>
                  <p>
                    Once you start a project and hire an artisan, it will
                    appear here.
                  </p>
                  <Link to="/new-project" className="empty-cta">
                    <FaRocket /> Start your first project
                  </Link>
                </div>
              )}
            </section>
          </div>
        )}

        {/* ============ ACTIVITY ============ */}
        {activeSection === 'activity' && (
          <div className="section-reveal">
            <div className="activity-full-grid">
              <section className="panel updates-card">
                <div className="panel-header">
                  <div className="panel-title">
                    <span className="panel-number">01</span>
                    <div>
                      <h2>
                        <FaBell /> Recent Updates
                      </h2>
                      <p>Latest activity from your projects</p>
                    </div>
                  </div>
                  <Link to="/project-updates" className="panel-link">
                    See all
                  </Link>
                </div>
                <div className="activity-timeline">
                  {data.update_notifications &&
                  data.update_notifications.length > 0 ? (
                    data.update_notifications.map((update) => (
                      <div
                        key={update.id}
                        className={`timeline-item ${
                          !update.is_read ? 'new' : ''
                        }`}
                      >
                        <div className="timeline-dot"></div>
                        <div className="timeline-content">
                          <div className="timeline-header">
                            <h4>{update.project_title}</h4>
                            {!update.is_read && (
                              <span className="new-badge">New</span>
                            )}
                          </div>
                          <p>{update.message}</p>
                          <span className="timeline-time">{update.time}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="empty-activity">
                      <p>No recent updates</p>
                    </div>
                  )}
                </div>
              </section>

              <section className="panel proposals-card">
                <div className="panel-header">
                  <div className="panel-title">
                    <span className="panel-number">02</span>
                    <div>
                      <h2>
                        <FaFileAlt /> Recent Proposals
                      </h2>
                      <p>Proposals from artisans on your projects</p>
                    </div>
                  </div>
                  <Link to="/my-requests" className="panel-link">
                    View all <FaChevronRight />
                  </Link>
                </div>
                <div className="proposals-list">
                  {data.proposal_notifications &&
                  data.proposal_notifications.length > 0 ? (
                    data.proposal_notifications.map((proposal) => (
                      <div key={proposal.id} className="proposal-item">
                        <div className="proposal-header">
                          <div className="proposal-project">
                            <h4>{proposal.project_title}</h4>
                            <span className="proposal-artisan">
                              {proposal.artisan_name}
                            </span>
                          </div>
                          <div className="proposal-price">
                            KSh{' '}
                            {proposal.proposed_price?.toLocaleString() || 0}
                          </div>
                        </div>
                        <div className="proposal-details">
                          <div className="proposal-footer">
                            <span className="proposal-date">
                              <FaCalendarAlt /> Due:{' '}
                              {proposal.completion_date
                                ? new Date(
                                    proposal.completion_date,
                                  ).toLocaleDateString()
                                : 'Not set'}
                            </span>
                            <Link
                              to="/projects"
                              className="review-proposal-btn"
                            >
                              Review <FaArrowRight />
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="empty-proposals">
                      <p>No proposals received yet</p>
                    </div>
                  )}
                </div>
              </section>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default withAuth(ClientDashboard, 'client');